<template>
  <div class="puttime-wrapper">

    <ul class="hours-container row">
      <li class="week-title">
        <el-checkbox v-model="checkAll" @change="handleCheckAll" :disabled="disabled" /> 全选
      </li>
      <li v-for="(item, index) in 24" :key="item" class="item">
        <el-checkbox-group v-model="checkList">
          <el-checkbox :label="index" @change="(value) => { checkChange(value, index) }" :disabled="disabled" />
        </el-checkbox-group>
      </li>
    </ul>

    <ul v-for="weekItem in 7" :key="weekItem" class="row">
      <li class="week-title">周{{ week[weekItem-1] }}</li>
      <li
        v-for="(hoursItem, index) in 24"
        @click="toggleItemCls(weekItem, index)"
        :class="{ active: handleHoursCls(weekItem, index) }"
        :key="index"
        class="item js-item">{{ index }}点</li>
    </ul>

  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: String,
    isAll: {
      type: Boolean,
      default: true
    }
  },
  emits: ['change'],
  data () {
    return {
      week: ['一', '二', '三', '四', '五', '六', '日'],
      data: [],
      checkAll: false,
      checkList: [], // 1-24
      vodi: 0
    }
  },
  created () {
    this.init()
  },
  watch: {
    value (newVal, oldVal) {
      this.init()
    },
    isAll () {
      if (this.isAll) {
        this.handleCheckAll(true)
      }
    }
  },
  mounted () {
    if (this.isAll) {
      this.handleCheckAll(true)
    }
  },
  methods: {
    init () {
      this.data = []
      this.checkList = []
      this.checkAll = false
      if (!this.value) return
      const tempValue = this.value + '|'
      tempValue.split(')|').filter(item => {
        return !!item
      }).forEach(item => {
        const arr = item.split('(')
        if (arr[0].indexOf('|') == 0) {
          arr[0] = arr[0].substring(1)
        }
        arr[1].split('|').forEach(hoursItem => {
          this.data.push(`${Number(arr[0]) === 0 ? 7 : arr[0]}_${Number(hoursItem)}`)
          this.toggleCheck(Number(hoursItem))
        })
      })
    },
    getValue () {
      const normalArr = [[], [], [], [], [], [], []]
      var normalStr = ''
      this.data.forEach(item => {
        const arr = item.split('_')
        normalArr[Number(arr[0]) === 7 ? 0 : Number(arr[0])].push(arr[1])
      })
      normalArr.forEach((item, index) => {
        if (item.length > 0) {
          normalStr += '|' + index + '('
          const tem = item.sort((a, b) => {
            a = Number(a)
            b = Number(b)
            return a - b
          })
          const value = tem.reduce((str, value) => {
            str = str.length < 2 ? '0' + str : str
            value = value < 10 ? '0' + value : value
            return str + '|' + value
          })
          normalStr += (value.length === 1 ? '0' + value : value) + ')'
        }
      })
      return normalStr
    },

    /* hours is active */
    handleHoursCls (weekItem, hoursItem) {
      if (this.data.indexOf(`${weekItem}_${hoursItem}`) > -1) {
        return true
      }
      return false
    },

    toggleItemCls (weekItem, hoursItem) {
      if (this.disabled) return

      const index = this.data.indexOf(`${weekItem}_${hoursItem}`)
      if (index > -1) {
        this.data.splice(index, 1)
      } else {
        this.data.push(`${weekItem}_${hoursItem}`)
      }
      this.toggleCheck(hoursItem)
    },
    toggleCheck (hoursItem) {
      let tem = 0
      const checkIndex = this.checkList.indexOf(hoursItem)
      this.data.forEach(item => {
        if (parseInt(item.split('_')[1]) === hoursItem) {
          tem += 1
        }
      })
      if (checkIndex > -1 && tem < 7) {
        this.checkList.splice(checkIndex, 1)
      } else if (checkIndex < 0 && tem >= 7) {
        this.checkList.push(hoursItem)
      }
      if (this.checkList.length < 24) {
        this.checkAll = false
      } else {
        this.checkAll = true
      }
      this.change()
    },

    checkChange (value, hoursItem) {
      if (this.checkList.length < 24) {
        this.checkAll = false
      } else {
        this.checkAll = true
      }
      this.disOneCheck(value, hoursItem)
      this.change()
    },
    handleCheckAll (value) {
      const tem = []
      for (let i = 0; i < 24; i++) {
        tem.push(i)
        this.disOneCheck(value, i)
      }
      this.checkList = value ? tem : []
      this.change()
    },
    disOneCheck (value, hoursItem) {
      if (value) {
        for (let i = 1; i < 8; i++) {
          if (this.data.indexOf(`${i}_${hoursItem}`) < 0) {
            this.data.push(`${i}_${hoursItem}`)
          }
        }
      } else {
        for (let i = 1; i < 8; i++) {
          const index = this.data.indexOf(`${i}_${hoursItem}`)
          if (index > -1) {
            this.data.splice(index, 1)
          }
        }
      }
    },
    change () {
      this.$emit('change', this.getValue())
    },
    resetValue () {
      this.data = []
    }

  }
}
</script>

<style lang="scss" scoped>
ul,li{
  margin: 0;
  padding: 0;
}
.puttime-wrapper{
  width: 992px;
  font-size: 12px;
  background: $--common-bg-color;
}
// .row{
//   padding: 10px 0;
// }
ul>li{
  display: inline-block;
  border: 1px solid $--common-card-color;
  box-sizing: border-box;
}
.week-title{
  width: 80px;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  text-align: center;
}
.item{
  width: 38px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  cursor: pointer;
  &:hover{
    color: #53a8ff;
  }
  &.active{
    color: #ffffff;
    background: #53a8ff;
    &:hover{
      color: #ffffff;
    }
  }
}

::v-deep .el-checkbox__label{
  display: none;
}
</style>
